<template>
  <div
    class="d-flex flex-column justify-content-center align-items-center"
    v-touch:swipe="onTouch"
  >
    <transition name="fade" mode="out-in">
      <GalleryCarousel
        class="crsl-size pt-5"
        @back="back"
        @next="next"
        :media="medias[i]"
        :key="i"
      ></GalleryCarousel>
    </transition>
    <div class="pagin-p">
      <VPagination
        v-model="currentPage"
        class="my-4 items-pag mx-auto"
        active-color="#ffffff2a"
        :pages="this.nbPages"
        :range-size="1"
        @update:modelValue="pageChange"
      ></VPagination>
    </div>
    <div
      class="return-area-button d-flex align-items-start flex-wrap pb-5 p-2"
    >
      <button class="content-return my-2" name="" @click="backHistory">
        <i class="fa fa-arrow-left"></i>
      </button>
    </div>
    <div
      class="items d-flex justify-content-around align-items-center flex-wrap p-2"
    >
      <img
        class="items-border m-1"
        :class="{ 'items-selected': i === (index + (currentPage - 1) * elPerPage) }"
        v-for="(media, index) in paginatedMedias"
        :key="media.id"
        :src="thumbnail(media)"
        alt=""
        @click="changeCurrent(index)"
        loading="lazy"
      />
    </div>
    <VPagination
      v-model="currentPage"
      class="mt-4 mb-3 items-pag mx-auto"
      active-color="#ffffff2a"
      :pages="this.nbPages"
      :range-size="1"
      @update:modelValue="pageChange"
    ></VPagination>
  </div>
</template>
<script> 
import GalleryCarousel from "@/components/GalleryCarousel/GalleryCarousel.vue";
import VPagination from "@hennge/vue3-pagination";
import "@hennge/vue3-pagination/dist/vue3-pagination.css";

export default {
  components: {
    GalleryCarousel,
    VPagination,
  },
  data() {
    return {
      i: 4,
      /*medias: this.$store.state.gallery.medias,*/
      /*max: this.$store.state.gallery.total,*/
      currentPage: 1,
      elPerPage: 10,
    };
  },
  computed: {
    medias() {
      return this.$store.state.gallery.medias;
    },
    maxIndex() {
      return this.medias.length - 1;
    },
    nbPages() {
      return Math.ceil(this.medias.length / this.elPerPage);
    },
    paginatedMedias() {
      const start = (this.currentPage - 1) * this.elPerPage;
      return this.medias.slice(start, start + this.elPerPage);
    },
  },
  methods: {
    pageChange(page) {
      this.currentPage = page;
      this.i = (page - 1) * this.elPerPage;
      if (this.i >= this.medias.length) this.i = this.medias.length - 1;
      window.scrollTo({ top: 0, behavior: "smooth" });
    },
    changeCurrent(localIndex) {

      this.i = localIndex + (this.currentPage - 1) * this.elPerPage;
      window.scrollTo({ top: 0, behavior: "smooth" });
    },
    onTouch(e) {
      switch (e) {
        case "left":
          this.next();
          break;
        case "right":
          this.back();
          break;
        default:
          break;
      }
    },
    next() {
      if (this.i < this.maxIndex) {
        this.i++;
        const newPage = Math.floor(this.i / this.elPerPage) + 1;
        if (newPage !== this.currentPage) {
          this.currentPage = newPage; // Automatically updates pagination UI
        }
      } else {
        this.i = 0; // Wrap to beginning
        this.currentPage = 1;
      }
    },
    back() {
      if (this.i > 0) {
        this.i--;
        const newPage = Math.floor(this.i / this.elPerPage) + 1;
        if (newPage !== this.currentPage) {
          this.currentPage = newPage; // Automatically updates pagination UI
        }
      } else {
        this.i = this.maxIndex; // Wrap to end
        this.currentPage = this.nbPages;
      }
    },
    thumbnail(media) {
      if (media.type == "video") {
        let id = media.url.split("embed/");
        return `https://img.youtube.com/vi/${id[1]}/0.jpg`;
      } else {
        return media.url;
      }
    },
    backHistory() {
      if (this.$router.currentRoute.value.name === "gallery") {
        this.$router.replace({ name: "parc" });
      } else {
        this.$router.back();
      }
    },
  },
};
</script>
<style src="./Gallery.css"></style>
